<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'ArticleEnteteEnBref'
});
</script>
<template>
  <ka-container
    code="article-entete-en-bref"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text code="h-1">
      <h1 v-html="componentInstance.$articleTitle.value" />
    </ka-text>
    <ka-text
      code="sous-titre"
      :value="componentInstance.$subtitle.value" />
    <!-- Container - en bref -->
    <ka-container code="container-en-bref">
      <ka-text
        code="en-bref"
        :value="componentInstance.$inShort.value" />
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { articleEnteteEnBrefComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c29')
const component = articleEnteteEnBrefComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  articleTitle?: Nullable<string>
  subtitle?: Nullable<string>
  inShort?: Nullable<string>
  part1?: Nullable<string>
  part2?: Nullable<string>
  part3?: Nullable<string>
  part4?: Nullable<string>
  part5?: Nullable<string>
  part6?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  articleTitle: '<strong>Titre de l\'article </strong>',
  subtitle: '',
  inShort: '<p style="margin-left:0px;"><strong>EN BREF </strong></p><p style="margin-left:0px;"> </p><p style="margin-left:0px;">Concernant la <strong>contribution à la formation pro et l’alternance</strong>, depuis 2022, tout devait être simplifié avec UNE contribution UNIQUE prélevée AUTOMATIQUEMENT par l’URSSAF pour qu’elle redistribue ensuite la somme des contributions aux différents acteurs de la formation. </p><p style="margin-left:0px;"> </p><p style="margin-left:0px;">Néanmoins, certaines conventions collectives et notamment <strong>Syntec - bureaux d\'études techniques [IDCC 1486]</strong>  ont fixé un taux supérieur à celui fixé par la loi. </p>',
  part1: 'Partie 1',
  part2: 'Partie 2 ',
  part3: 'Partie 3',
  part4: 'Partie 4',
  part5: 'Partie 5',
  part6: 'Partie 6',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:articleTitle',
  'update:subtitle',
  'update:inShort',
  'update:part1',
  'update:part2',
  'update:part3',
  'update:part4',
  'update:part5',
  'update:part6'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    articleTitle: true,
    subtitle: true,
    inShort: true,
    part1: true,
    part2: true,
    part3: true,
    part4: true,
    part5: true,
    part6: true
  }
})
</script>
